exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link__link___SSePR {\n  transition: 300ms; }\n  .link__link___SSePR:hover {\n    filter: brightness(1.15); }\n", ""]);

// exports
exports.locals = {
	"link": "link__link___SSePR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/Link/link.scss
// module id = 3998
// module chunks = 6